module.exports = {
	"api_url": "https://migration.transferhlediagrh.fr/api/",
	"front_url": "http://migration.transferhlediagrh.fr/",
	"refreshToken": 3600,
	"version": "1.1.3"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/settings.json
// module id = 5
// module chunks = 0